import React from "react";
import "./ProgressBar.css"

const ProgressBar = props => {
    return(
        <div className="ProgressBar">
            <div className="xp-qnt"></div>
        </div>
    );
}

export default ProgressBar;